import { useEffect } from 'react';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import TaskList from '@/components/tasks/TaskList';
import TaskDetail from '@/components/tasks/TaskDetail';
import TaskHistory from '@/components/tasks/TaskHistory';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useTasks } from '@/hooks/useTasks';
import EmptyState from '@/components/common/EmptyState';
import Spinner from '@/components/common/Spinner';

export default function TasksPage() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 767px)');
  const isHistory = location.pathname.endsWith('/history');
  const { data, isLoading } = useTasks('active');

  // On desktop, auto-select the first task if none is selected
  useEffect(() => {
    if (!isMobile && !id && !isHistory && data && data.tasks.length > 0) {
      navigate(`/app/tasks/${data.tasks[0].task_id}`, { replace: true });
    }
  }, [isMobile, id, isHistory, data, navigate]);

  // History view
  if (isHistory) {
    return <TaskHistory />;
  }

  // On mobile, show either the list or the detail view
  if (isMobile) {
    if (id) {
      return <TaskDetail />;
    }
    return <TaskList />;
  }

  // On desktop, the sidebar handles the list; this page shows the detail view
  if (id) {
    return <TaskDetail />;
  }

  // While loading, show a spinner instead of the empty state to avoid a flash
  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner />
      </div>
    );
  }

  // No tasks exist — show empty state
  return (
    <div className="flex h-full items-center justify-center">
      <EmptyState
        title="Select a move"
        description="Choose a move from the sidebar to see its details"
        icon={
          <svg className="h-16 w-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
            />
          </svg>
        }
      />
    </div>
  );
}
